import { gsap } from "gsap";


const searchPopUp = {
    popUpNode: null,
    openButton: null,
    closeButton: null,
    openSearchPopUpReference: null,
    closeSearchPopUpReference: null,
    closeListener: null,

    init() {
        let self = this;
        self.popUpNode = document.querySelector('.js-search-popup');

        if(! self.popUpNode) {
            return;
        }

        self.createListeners();
    },

    reInit() {
        let self = this;

        self.closeSearchBarPopUp(self);
        self.destroyListeners();
        self.init();
    },

    createListeners() {
        let self = this;

        self.openButton = document.querySelector('.js-search-button');
        self.closeButton = self.popUpNode.querySelector('.js-search-bar-close-button');

        self.openSearchPopUpReference = self.openSearchBarPopUp.bind(null, self);
        self.closeSearchPopUpReference = self.closeSearchBarPopUp.bind(null, self);

        self.openButton.addEventListener('click', self.openSearchPopUpReference, false);
        self.closeButton.addEventListener('click', self.closeSearchPopUpReference, false);   
    },

    destroyListeners() {
        let self = this;
        self.openButton.removeEventListener('click',  self.openSearchPopUpReference, false);
        self.closeButton.removeEventListener('click',  self.closeSearchPopUpReference, false);
    },

    openSearchBarPopUp(self) {
        self.popUpNode.classList.remove('hidden');
        window.navBarMobileMenu.navbar.closeMainMenu();
        gsap.from(self.popUpNode, {autoAlpha: 0, duration: 0.3});
        gsap.from(self.popUpNode.querySelector('.js-search-popup > div'), {autoAlpha: 0, duration: 0.3, y: -50});
    },

    closeSearchBarPopUp(self) {
        gsap.to(self.popUpNode, {autoAlpha: 0, duration: 0.3, delay: 0.1, onComplete:function(){
            self.popUpNode.removeAttribute('style');
            self.popUpNode.classList.add('hidden');
        }});
    }
};

window.searchPopUp = searchPopUp;

searchPopUp.init();

document.addEventListener('LokiRequestEnd', function () {
    searchPopUp.reInit();
});
